import { getDefaultDateRange } from '@shared/utils/formatDate';

/**
 * 검색필터의 항목
 * @param {} filterValues
 * @param {*} formOptions
 * @returns
 */
export function getFilterFields(filterValues, formOptions) {
  const defaultRange = getDefaultDateRange();
  return [
    {
      key: 'dateRange',
      type: 'dateRange',
      label: '조회기간',
      startPlaceholder: defaultRange.start,
      endPlaceholder: defaultRange.end,
      startKey: 'date1',
      endKey: 'date2',
      startValue: filterValues.date1,
      endValue: filterValues.date2,
    },
    {
      key: 'stateCode',
      type: 'select',
      label: '문서상태',
      value: filterValues.stateCode ?? '',
      options: [
        { label: '전체', value: '' },
        { label: '결재대기', value: 1 },
        { label: '결재중', value: 2 },
        { label: '결재완료', value: 3 },
        { label: '반려', value: 4 },
      ],
    },
    { newRow: true },
    {
      key: 'docType',
      type: 'select',
      label: '문서유형',
      value: filterValues.docType ?? '',
      options: formOptions,
    },

    { newRow: true },
    {
      key: 'title',
      type: 'input',
      label: '문서제목',
      placeholder: '제목',
      wide: '550px',
      value: filterValues.title ?? '',
    },
    {
      key: 'name',
      type: 'input',
      label: '기안자',
      placeholder: '홍길동',
      value: filterValues.name ?? '',
    },
  ];
}
